export default __webpack_public_path__ + "static/media/AliensCh3.7dbc7505.svg";